module.exports = __webpack_public_path__ + "img/1.ace94776.jpg";